import { render, staticRenderFns } from "./NewSubjectAddSemester.vue?vue&type=template&id=a9b6a3d2&"
import script from "./NewSubjectAddSemester.vue?vue&type=script&lang=js&"
export * from "./NewSubjectAddSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports